
define('ldsh!modules/form_editor/templates/editor_dropdown_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="flex align-center gap-8">\n  <input type="text" class="ed-form-control js-text" value="' +
((__t = ( text )) == null ? '' : __t) +
'">\n  <span class="flex align-center gap-4">\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-toggle-value"\n      data-i18n="[title]formEditor.toolbar.editValue"\n    >\n      <span class="ri-code-s-slash-fill"></span>\n    </button>\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-add"\n      data-i18n="[title]formEditor.toolbar.addItem"\n    >\n      <span class="ri-add-line"></span>\n    </button>\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-remove"\n      data-i18n="[title]formEditor.toolbar.removeItem"\n    >\n      <span class="ri-delete-bin-6-line"></span>\n    </button>\n  </span>\n</div>\n<p class="ed-input-value ed-form-group-row hidden js-item-value">\n  <span class="ed-value-label" data-i18n="formEditor.dropDownItemValue">Valor</span>\n  <input type="text" value="' +
((__t = ( value )) == null ? '' : __t) +
'" class="ed-form-control js-value-text">\n</p>\n';

}
return __p
};});

